import React from 'react'

import { Table, TableBody, TableHead, TableRow } from '@material-ui/core'

import useStyles, { StyledTableCell, StyledTableRow } from './Table.styles'

const CustomTable = ({ rows = [], columns = [], footer = null }) => {
  const classes = useStyles()

  return (
    <Table className={classes.container} aria-label="customized table">
      <TableHead>
        <TableRow>
          {columns.map(({ label }, i) => (
            <StyledTableCell align="center" key={i}>
              {label}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => (
          <StyledTableRow key={`${row.id}-${i}`}>
            {columns.map(({ key, applyFormat }) => (
              <StyledTableCell
                align="center"
                component="th"
                scope="row"
                key={`${key}-${i}`}
              >
                {applyFormat ? applyFormat(row[key], row, i) : row[key]}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        ))}
      </TableBody>
      {footer}
    </Table>
  )
}

export default CustomTable
